import { MainContent, TopBar } from '@domain-group/suit-theme'

import {
  ArtworkDownloadProvider,
  ArtworkBuilderProvider,
  // @ts-expect-error
  setAccessToken as setArtworkBuilderAccessToken,
} from '@domain-group/artwork-builder'

import { getAccessToken } from '@functions/accessToken'

import useMainNavigation from '@hooks/useMainNavigation'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import Notifications from '@components/Notifications'

import MainNavigation from '@sections/Admin/components/MainNavigation'

import useSystemManagerNestedNavigation from '@hooks/useSystemManagerNestedNavigation'

import { useEffect } from 'react'
import NestedNavigation from './components/NestedNavigation'

import SystemManagerRoutes from './routes'

const SystemManager = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  const navigationPayload = useSystemManagerNestedNavigation()
  const { shouldUseNestedNavigation } = navigationPayload

  const leftOffset = shouldUseNestedNavigation ? undefined : 220

  // Set accessToken for ArtworkBuilder
  useEffect(() => {
    setArtworkBuilderAccessToken(getAccessToken())
  }, [])

  return (
    <ArtworkBuilderProvider>
      <ArtworkDownloadProvider
        configOptions={{ ablyPublicKey: process.env.REACT_APP_ABLY_ARTWORK_BUILDER_PUBLIC_KEY || '' }}
      >
        <TopBar
          callbacks={{ toggleNavigation }}
          loggedInUserComponent={<LoggedInUser />}
          nestedNavigation={shouldUseNestedNavigation}
          notificationsComponent={<Notifications />}
          offset={{ left: leftOffset }}
          searchComponent={<DashboardSearch />}
        />

        <MainNavigation
          minimized={shouldUseNestedNavigation}
          nestedNavigation={<NestedNavigation navigationPayload={navigationPayload} />}
        />

        <MainContent
          nestedNavigation={shouldUseNestedNavigation}
          offset={{ left: leftOffset, top: TopBar.topBarHeight }}
        >
          <SystemManagerRoutes />
        </MainContent>
      </ArtworkDownloadProvider>
    </ArtworkBuilderProvider>
  )
}

export default SystemManager
